import { LoadingSVG } from "./loading-icon.styles";

const LoadingIcon = () => {
  return (
    <>
      <LoadingSVG />
    </>
  );
};

export default LoadingIcon;
